export class OfflineError extends Error {}
